import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-wdt",
  "use": "icon-wdt-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-wdt\"><defs><style type=\"text/css\"></style></defs><path d=\"M833.697308 1024H187.444068C83.921037 1024 0 940.078963 0 836.76012V190.506879C0 86.983848 83.921037 3.062812 187.444068 3.062812h646.25324c103.523031 0 187.444068 83.921037 187.444068 187.444067v646.253241c-0.204187 103.318843-84.125224 187.23988-187.444068 187.23988z\" fill=\"#287BED\" p-id=\"3027\" /><path d=\"M353.448455 378.359322l-127.004587-0.81675 30.832303-108.423529 126.800399 0.408375z\" fill=\"#FFFFFF\" p-id=\"3028\" /><path d=\"M222.564307 401.840877l122.920838 0.612563-65.135793 237.878365 118.020339 3.675373 98.622532-376.93001h122.71665l-97.19322 373.254637 145.177268 1.020937 99.847657-374.275574L890.257228 269.527418l-91.884347 357.532203-102.502093 126.187837-565.190828 0.612562z\" fill=\"#FFFFFF\" p-id=\"3029\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wdt.svg
// module id = Oflp
// module chunks = 111